import { useState, useRef, useCallback } from "react";
import { usePlanStore } from "./usePlanStore";

export function usePlanManagement(clientId) {
  const { plans, savePlan, updatePlan, deletePlan } = usePlanStore(clientId);
  const [activePlanId, setActivePlanId] = useState(null);
  const [planKey, setPlanKey] = useState(0);
  const snapshotRef = useRef(null);
  const tabNotesRef = useRef({});
  const sectionNotesRef = useRef({});

  const handleTabNotesChange = useCallback((notes) => {
    tabNotesRef.current = notes;
  }, []);

  const handleSectionNotesChange = useCallback((notes) => {
    sectionNotesRef.current = notes;
  }, []);

  const handleSavePlan = (name) => {
    const id = savePlan(name, {
      ...snapshotRef.current,
      tabNotes: tabNotesRef.current,
      sectionNotes: sectionNotesRef.current,
    });
    setActivePlanId(id);
    setPlanKey(k => k + 1);
  };

  const handleUpdatePlan = () => {
    if (!activePlanId) return;
    updatePlan(activePlanId, {
      ...snapshotRef.current,
      tabNotes: tabNotesRef.current,
      sectionNotes: sectionNotesRef.current,
    });
  };

  const handleDeletePlan = (planId) => {
    deletePlan(planId);
    if (planId === activePlanId) {
      setActivePlanId(null);
      setPlanKey(k => k + 1);
    }
  };

  const handleLoadPlan = (plan) => {
    setActivePlanId(plan.id);
    setPlanKey(k => k + 1);
  };

  const activePlan = plans.find(p => p.id === activePlanId);
  const loadedPlanData = activePlan ? activePlan.data : null;

  return {
    plans, activePlanId, planKey, loadedPlanData, snapshotRef,
    handleTabNotesChange, handleSectionNotesChange,
    handleSavePlan, handleUpdatePlan, handleDeletePlan, handleLoadPlan,
  };
}
